import _default from './Confirm';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/Confirm/index.js
// module id = 389
// module chunks = 0